import { format, isSameDay } from 'date-fns';
import { get } from 'lodash';
import { DATE_FORMAT_SLASH, SHORT_LOCALIZED } from '@/constants';
import { Formatter } from '@/core/utils/Formatter';
import { type DateRange } from '@/types';
import { useFiltersContext } from '../../../context/FiltersContextProvider';
import { MAX_SAFE_DATE, TimeFilterPresets } from '../TimeFilterControl.const';

const getFormattedDateRangeLabel = (dateRange: DateRange[], pattern: string) => {
  const fromDate = Formatter.toUTC(get(dateRange, '[0].from'));
  const toDate = Formatter.toUTC(get(dateRange, '[0].to'));
  const isMaxSafeDate = isSameDay(toDate, MAX_SAFE_DATE);

  const formattedFrom = format(fromDate, pattern);
  const formattedTo = !isMaxSafeDate ? format(toDate, pattern) : '...';

  return isSameDay(fromDate, toDate) ? formattedFrom : `${formattedFrom} - ${formattedTo}`;
};

export const useButtonLabelByPreset = () => {
  const {
    filters: { dateRange },
  } = useFiltersContext();

  return (preset: TimeFilterPresets | null): string | null => {
    switch (preset) {
      case TimeFilterPresets.CURRENT_DAY:
        return getFormattedDateRangeLabel(dateRange, SHORT_LOCALIZED);
      case TimeFilterPresets.CURRENT_WEEK:
      case TimeFilterPresets.CURRENT_MONTH:
      case TimeFilterPresets.CURRENT_YEAR:
      case TimeFilterPresets.CUSTOM_RANGE:
      case TimeFilterPresets.FUTURE:
        return getFormattedDateRangeLabel(dateRange, DATE_FORMAT_SLASH);
      default:
        return null;
    }
  };
};
